import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TOKEN_KEY = "zenova_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const client = axios.create({ baseURL: API });
client.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
client.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      clearToken();
      if (window.location.pathname.startsWith("/admin") && !window.location.pathname.endsWith("/login")) {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  }
);

export const adminApi = {
  login: (username, password) => client.post("/admin/login", { username, password }),
  me: () => client.get("/admin/me"),
  changePassword: (currentPassword, newPassword) =>
    client.post("/admin/change-password", { currentPassword, newPassword }),

  // Content
  getContent: () => client.get("/content"),
  saveContent: (content) => client.put("/content", content),

  // Enquiries
  listEnquiries: (params = {}) => client.get("/enquiries", { params }),
  countEnquiries: () => client.get("/enquiries/count"),
  updateEnquiry: (id, body) => client.patch(`/enquiries/${id}`, body),
  deleteEnquiry: (id) => client.delete(`/enquiries/${id}`),
  exportUrl: () => `${API}/enquiries/export.csv`,
};

// Public content fetch (no auth)
export const fetchPublicContent = () => axios.get(`${API}/content`).then((r) => r.data);
